export default "__VITE_ASSET__61b6f925__"